import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Root from "./Root";

// Sentry — no-op if REACT_APP_SENTRY_DSN is not set
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.NODE_ENV,
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 1.0,
    });
  });
}

// Google Analytics 4 — no-op if REACT_APP_GA_ID is not set
const GA_ID = process.env.REACT_APP_GA_ID;
if (GA_ID) {
  const s1 = document.createElement("script");
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s1);
  const s2 = document.createElement("script");
  s2.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${GA_ID}');`;
  document.head.appendChild(s2);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
